module.exports = __webpack_public_path__ + "static/media/pau_full.9c52faec.jpg";